type Params = {
  isTelephony: boolean
  isGdprSettingsEnabled: boolean
}

export function getUiSchema({ isGdprSettingsEnabled, isTelephony }: Params) {
  const widgetHidden = { 'ui:widget': 'hidden' }

  return {
    'ui:order': ['testMode', 'sdkVersion', '*'],
    id: widgetHidden,
    version: widgetHidden,

    errors: {
      'ui:field': 'CollapsibleObject',
      collapsibleGroup: 'default',
      'ui:classNames': 'e2e-errors',
      errorDialog: {
        'ui:widget': 'DialogCreatableSelectWidget'
      }
    },

    knowledgeBases: widgetHidden,

    gdpr: isGdprSettingsEnabled
      ? {
          'ui:field': 'CollapsibleObject',
          collapsibleGroup: 'default',
          'ui:classNames': 'bot-settings-gdpr',
          keepStorages: {
            items: { 'ui:label': false }
          }
        }
      : widgetHidden,
    mainDialogs: {
      'ui:field': 'CollapsibleObject',
      collapsibleGroup: 'default',
      'ui:classNames': 'e2e-mainDialogs',
      items: {
        'ui:label': false,
        id: { 'ui:widget': 'DialogCreatableSelectWidget' }
      }
    },
    variables: widgetHidden,
    handoff: {
      'ui:field': 'CollapsibleObject',
      collapsibleGroup: 'default',
      'ui:classNames': 'e2e-handoff',
      variables: {
        items: { 'ui:label': false }
      }
    },

    intro: {
      'ui:field': 'CollapsibleObject',
      collapsibleGroup: 'default',
      'ui:classNames': 'e2e-intro',
      dialog: { 'ui:widget': 'DialogCreatableSelectWidget', 'ui:clearable': false }
    },
    stepTypeDefaults: {
      'ui:field': 'CollapsibleObject',
      collapsibleGroup: 'default',
      'ui:classNames': 'e2e-stepTypeDefaults',
      email: {
        bodyPrefix: { 'ui:widget': 'textarea' },
        bodyPostfix: { 'ui:widget': 'textarea' },
        buttons: {
          items: { 'ui:label': false }
        }
      },
      message: isTelephony ? widgetHidden : {},
      question: {
        fuzzyAnswers: {
          'ui:widget': 'InfoTextWidget',
          'ui:options': {
            text: 'This setting was moved under NLP settings → Step NLP tab → enabled'
          }
        },
        grammars: {
          items: {
            'ui:label': false,
            sentences: {
              items: { 'ui:label': false }
            }
          }
        }
      }
    },
    integrations: {
      'ui:field': 'CollapsibleObject',
      collapsibleGroup: 'default',
      'ui:classNames': 'e2e-integrations',
      repository: {
        sources: {
          items: {
            type: widgetHidden,
            'ui:label': false
          }
        }
      }
    },

    nlp: {
      'ui:field': 'CollapsibleObject',
      collapsibleGroup: 'default',
      'ui:classNames': 'e2e-nlp',
      triggers: {
        items: {
          'ui:label': false,
          dialog: { 'ui:widget': 'DialogCreatableSelectWidget' }
        }
      },
      training: {
        ignoredUtterances: {
          items: { 'ui:label': false }
        }
      },
      test: {
        cases: {
          items: { 'ui:label': false }
        }
      }
    },
    storages: {
      'ui:field': 'CollapsibleObject',
      collapsibleGroup: 'default',
      'ui:classNames': 'e2e-storages',
      items: {
        type: widgetHidden,
        'ui:label': false,
        startFromColumns: {
          items: { 'ui:label': false }
        }
      }
    },
    mutations: {
      'ui:field': 'CollapsibleObject',
      collapsibleGroup: 'default',
      'ui:classNames': 'e2e-mutations',
      items: {
        id: {
          'ui:widget': 'BotMutationWhisperWidget'
        },
        options: {
          items: { 'ui:label': false }
        }
      }
    },
    localizations: {
      'ui:field': 'CollapsibleObject',
      collapsibleGroup: 'default',
      'ui:classNames': 'e2e-localizations'
    },

    backButton: {
      'ui:field': 'CollapsibleObject',
      collapsibleGroup: 'default',
      'ui:classNames': 'e2e-backButton',
      localizations: {
        items: {
          'ui:label': false,
          triggers: {
            items: { 'ui:label': false }
          }
        }
      }
    }
  }
}
